import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import axios from "axios";
import config from "../../config";

const OnboardingCarousel = ({ images, onDisable }) => {
  const [show, setShow] = useState(true);

  const handleDisable = async () => {
    try {
      // call API to set carousel_images = 1
      const user = JSON.parse(localStorage.getItem("ship_rocket_user"));
      await axios.post(
        `${config.apiUrl}/shipment/update_carousel_status`,
        { customerId: user.customer_id, status: 1 },
        { headers: config.headers }
      );
      setShow(false);
      if (onDisable) onDisable();
    } catch (err) {
      console.error("Failed to update carousel status:", err);
    }
  };

  if (!show) return null;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 
                 d-flex align-items-center justify-content-center"
      style={{ zIndex: 1050 }}
    >
      <div
        className="bg-white rounded shadow-lg p-3 position-relative"
        style={{ width: "80%", maxWidth: "800px" }}
      >
        {/* Close Button */}
        <button
          type="button"
          aria-label="Close carousel"
          onClick={() => setShow(false)}
          className="btn btn-danger"
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            fontSize: 20,
            cursor: "pointer",
            zIndex: 1100,
          }}
        >
          ✕
        </button>

        {/* Carousel */}
        <Carousel>
          {images.map((img, idx) => (
            <Carousel.Item key={idx}>
              <img
                className="d-block w-100 rounded"
                src={img}
                alt={`Step ${idx}`}
              />
            </Carousel.Item>
          ))}
        </Carousel>

        {/* Disable Button */}
        <div className="text-end mt-3">
          <button className="btn btn-outline-secondary btn-sm" onClick={handleDisable}>
            Do not show on startup
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingCarousel;
